import React, { useEffect, useState } from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import cn from 'classnames';
import { useUnit } from 'effector-react';

import { LineChart } from '../../../../components/Chart/LineChart';
import { ClientDetails$, clientDetailsApi } from '../../../../effector/clientDetails';

type Period = {
  key: string;
  value: string;
};

const periods: Period[] = [
  { key: 'ytd', value: 'YTD' },
  { key: '1m', value: '1 мес' },
  { key: '3m', value: '3 мес' },
  { key: '6m', value: '6 мес' },
  { key: '1y', value: '1 год' },
  { key: 'all', value: 'Весь период' },
];

export const ProfitChart: React.FC<{ agreementId: string }> = ({ agreementId }) => {
  const { pnlHistory } = useUnit(ClientDetails$);
  const isLoading = useUnit(clientDetailsApi.getPnlHistory.pending);
  const [period, setPeriod] = useState(periods[periods.length - 1]);

  useEffect(() => {
    clientDetailsApi.getPnlHistory({ agreementId, period: period.key });
  }, [agreementId, period]);

  return (
    <Box sx={{ mt: 2 }}>
      <div className="strategy-chart__periods">
        {periods.map((item) => (
          <span
            className={cn('strategy-chart__period', {
              'strategy-chart__period-active': period.key === item.key,
            })}
            key={item.key}
            onClick={() => setPeriod(item)}
          >
            {item.value}
          </span>
        ))}
      </div>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Итоговый PnL клиента: {pnlHistory.profit}%
          </Typography>
          {pnlHistory.history.length > 0 && (
            <LineChart
              data={pnlHistory.history}
              legends={{
                vc: 'доходность стратегии с издержками',
                c: 'доходность клиента',
              }}
            />
          )}
        </>
      )}
    </Box>
  );
};
